import * as constants from './QuestionList.constants';
import * as services from './QuestionList.service';

const state = {
  qTags: {},

  qList: {},
  searchList: {},

  isRequest: false,
};

const mutations = {
  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },

  [constants.GET_QA_QUESTION_TAGS_SUCCESS](state, qTags) {
    state.qTags = qTags;
  },

  [constants.GET_QA_QUESTION_LIST_SUCCESS](state, qList) {
    if (undefined !== qList && null !== qList) {
      state.qList = qList;
    }
  },

  [constants.GET_QA_SEARCH_LIST_SUCCESS](state, searchList) {
    if (undefined !== searchList && null !== searchList) {
      state.searchList = searchList;
    }
  },
};

const actions = {
  async getQaQuestionTags({ commit }, payload) {
    const res = await services.getQaQuestionTags(payload);
    commit(constants.GET_QA_QUESTION_TAGS_SUCCESS, res.data.data);
  },

  async getPublicQaQuestionList({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getPublicQaQuestionList(payload);
    commit(constants.GET_QA_QUESTION_LIST_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async getQaQuestionList({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getQaQuestionList(payload);
    commit(constants.GET_QA_QUESTION_LIST_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async getQaSearchList({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getQaSearchList(payload);
    commit(constants.GET_QA_SEARCH_LIST_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },
};

const getters = {
  qTags: (state) => state.qTags,

  myQuestionsCount: (state) => {
    return state.qList.myQuestionsCount ? state.qList.myQuestionsCount : 0;
  },
  myAnswersCount: (state) => {
    return state.qList.myAnswersCount ? state.qList.myAnswersCount : 0;
  },
  myFollowsCount: (state) => {
    return state.qList.myFollowsCount ? state.qList.myFollowsCount : 0;
  },

  myQuestionsMarkedUnread: (state) => state.qList.myQuestionsMarkedUnread,
  myFollowsMarkedUnread: (state) => state.qList.myFollowsMarkedUnread,
  myAnswersMarkedUnread: (state) => state.qList.myAnswersMarkedUnread,

  itemsCount: (state) => {
    return state.qList.itemsCount ? state.qList.itemsCount : 0;
  },
  pageCount: (state) => {
    return state.qList.pagesCount ? state.qList.pagesCount : 0;
  },
  questionList: (state) => {
    return state.qList.questions ? state.qList.questions : [];
  },

  searchTotal: (state) => {
    return state.searchList.total ? state.searchList.total : 0;
  },
  searchQaList: (state) => {
    return state.searchList.qas ? state.searchList.qas : [];
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
